import React from "react";
import { useTranslation } from 'react-i18next';

export default function NameFormatter({cell, row}) {
  const { t } = useTranslation();
  return(
     <div className="inner-tables-infos">
      <span className="normalTitle">{cell}</span>
      <span className="subTitle">{`${row.CountUnit} ${t('_count')}`}</span>
    </div>
  );
}